import { useMemo } from 'react';
import { EDIT_PROPERTIES_ALLOWLIST } from 'asset-actions-lib/constants/editPropertiesAllowlist';
import useFetchCrmObjectProperties from 'marketing-platform-lib/hooks/useFetchCrmObjectProperties';
export default function useDefaultProperties({
  crmObject
}) {
  const objectTypeId = useMemo(() => crmObject.objectTypeId, [crmObject]);
  const {
    data: crmObjectProperties,
    loading: loadingProperties,
    error: propertiesError
  } = useFetchCrmObjectProperties(objectTypeId);
  const crmObjectPropertiesAllowlist = useMemo(() => EDIT_PROPERTIES_ALLOWLIST[objectTypeId] || [], [objectTypeId]);
  const editableProperties = useMemo(() => crmObjectProperties && crmObjectProperties.filter(property => {
    const isReadOnly = property.readOnlyValue;
    const isHidden = property.hidden;
    const isInAllowlist = crmObjectPropertiesAllowlist.includes(property.name);
    return !isReadOnly && !isHidden || isInAllowlist;
  }).map(property => property.name), [crmObjectProperties, crmObjectPropertiesAllowlist]);
  const shouldRender = useMemo(() => Boolean(!propertiesError && !loadingProperties && crmObject && crmObjectProperties), [crmObject, crmObjectProperties, loadingProperties, propertiesError]);
  const defaultProperties = useMemo(() => {
    if (!shouldRender || !crmObject) {
      return {};
    }
    return Object.keys(crmObject.properties).reduce((acc, propKey) => {
      if (editableProperties && editableProperties.includes(propKey)) {
        acc[propKey] = crmObject.properties[propKey].value;
      }
      return acc;
    }, {});
  }, [crmObject, editableProperties, shouldRender]);
  return useMemo(() => ({
    shouldRender,
    defaultProperties
  }), [shouldRender, defaultProperties]);
}